/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */
import { v4 as uuid } from "uuid";

export const videos = [
  {
    _id: "ASzOzrB-a9E",
    title: "Battlefield 2042 Official Reveal Trailer",
    youtubeID: "ASzOzrB-a9E",
    videoLength: "4:50",
    videoThumbnail: "http://i3.ytimg.com/vi/ASzOzrB-a9E/hqdefault.jpg",
    likes: 120,
    views: 22000000,
    category: ["action", "adventure"],
    channelName: "Battlefield",
    channelThumbnail:
      "https://pbs.twimg.com/profile_images/1402665223685914630/qOzR7n_M_400x400.jpg",
    channelLink: "https://www.youtube.com/c/Battlefield",
    subscribers: "2.82M",
    date: "2021-09-06T20:30:14",
    description:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Neque odio iusto porro quasi quidem. Repudiandae odit at fuga.",
  },
  {
    _id: "68pYm_KgptU",
    title: "God of War: Ragnarok - Official Gameplay Trailer",
    youtubeID: "68pYm_KgptU",
    videoLength: "3:16",
    videoThumbnail: "http://i3.ytimg.com/vi/68pYm_KgptU/hqdefault.jpg",
    likes: 98000,
    views: 3600000,
    category: ["action", "adventure"],
    channelName: "IGN",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCKy1dAqELo0zrOtPkf0eTMw",
    subscribers: "16.5M",
    date: "2021-10-09T03:06:49",
    description:
      "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Neque odio iusto porro quasi quidem. Repudiandae odit at fuga.",
  },
  {
    _id: "I1AbCj6Ppwk",
    title: "Hogwarts Legacy: A Very Deep Dive Into The New Gameplay",
    youtubeID: "I1AbCj6Ppwk",
    videoLength: "14:56",
    videoThumbnail: "http://i3.ytimg.com/vi/I1AbCj6Ppwk/hqdefault.jpg",
    likes: 804,
    views: 17700,
    category: ["action", "adventure"],
    channelName: "WolfheartFPS",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCi3RdvCWYMzdF-iUgG_0xLQ",
    subscribers: "85.9K",
    date: "2022-01-10T04:01:23",
    description:
      "In today's video I am going to take a closer look at the gameplay revealed to us in the Hogwarts Legacy gameplay trailer. For more rpg content, subscribe. GAME: Hogwarts Legacy PC / Xbox Seriex X / One / Ps4 / Ps5",
  },
  {
    _id: "awcGsNZyOxA",
    title: "GRAN TURISMO 7 PS5 Walkthrough Gameplay Part 1",
    youtubeID: "awcGsNZyOxA",
    videoLength: "56:03",
    videoThumbnail: "http://i3.ytimg.com/vi/awcGsNZyOxA/hqdefault.jpg",
    likes: 19000,
    views: 540000,
    category: ["racing", "simulation"],
    channelName: "theRadBrad",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCpqXJOEqGS-TCnazcHCo0rA",
    subscribers: "13M",
    date: "2020-12-19T05:16:29",
    description:
      "Gran Turismo 7 GT7 PS5 Walkthrough Gameplay 1 includes a Review, Full Game Gameplay and Campaign Mission 1 for PS5, PlayStation 5, PS4 and PlayStation 4. My 2022 Gran Turismo 7 Gameplay Walkthrough will feature the Full Game Story Campaign. This Gran Turismo 7 Gameplay Walkthrough will also include a Review, All Cars, Customizations, Career Mode, Story Mode, Drifting, Soundtrack, OST, Money, PS5 Gameplay, PS4 Gameplay, PlayStation 5 and more until the Ending of the Single Player Career Story Mode! Thanks PlayStation for giving me Full Game of Gran Turismo 7!",
  },
  {
    _id: "vck7pnCjA-8",
    title: "FIFA 22 - PSG vs Manchester United | PS5™ Gameplay",
    youtubeID: "vck7pnCjA-8",
    videoLength: "23:34",
    videoThumbnail: "http://i3.ytimg.com/vi/vck7pnCjA-8/hqdefault.jpg",
    likes: 13000,
    views: 1200000,
    category: ["sports"],
    channelName: "Airton Silva",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCFUkISZuKPjUBoycTuzsBCA",
    subscribers: "273K",
    date: "2021-07-24T06:06:49",
    description:
      "Paris Saint Germain Vs Manchester United - FIFA 22 on PlayStation 5",
  },
  {
    _id: "vLj-27T-SEQ",
    title: "FIFA 22 | Official Gameplay Trailer",
    youtubeID: "vLj-27T-SEQ",
    videoLength: "3:47",
    videoThumbnail: "http://i3.ytimg.com/vi/vLj-27T-SEQ/hqdefault.jpg",
    likes: 93000,
    views: 3100000,
    category: ["sports"],
    channelName: "EA SPORTS FIFA",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCoyaxd5LQSuP4ChkxK0pnZQ",
    subscribers: "4.27M",
    date: "2021-11-12T11:06:49",
    description: `Go inside FIFA 22 with the Official Gameplay Trailer. Powered by Football™, FIFA 22 introduces HyperMotion Technology on PlayStation 5, Xbox Series X|S and Stadia, elevating every match across every mode: http://x.ea.com/69378
      - HyperMotion Technology unlocks:
      - Full Team Authentic Motion
      - Machine Learning Flow
      - Tactical A.I.
      - Kinetic Air Battles
      - Composed Ball Control
      - Player Humanization
      
      Plus, enjoy a Goalkeeper Rewrite, True Ball Physics, Explosive Sprint, New Attacking Tactics, an even more Immersive Matchday Experience, Big(ger) Goal Moments, and more fundamental advances all over the pitch. Learn more about FIFA 22 gameplay in our Pitch Notes: http://x.ea.com/69434`,
  },
  {
    _id: "K9nof302n0U",
    title: "Bugatti Divo - Forza Horizon 4 | Logitech g29 gameplay",
    youtubeID: "K9nof302n0U",
    videoLength: "13:31",
    videoThumbnail: "http://i3.ytimg.com/vi/K9nof302n0U/hqdefault.jpg",
    likes: 114000,
    views: 6700000,
    category: ["racing", "simulation"],
    channelName: "Xpertgamingtech",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCQvqWrkEHXWoOeocjiw8_KA",
    subscribers: "2.64M",
    date: "2020-06-10T08:46:29",
    description: `A freeroam drive in a Bugatti Divo, driven using Logitech g29 on Forza Horizon 4. Enjoy!`,
  },
  {
    _id: "k0L8aWP-fCc",
    title: "Cricket 22 PS5 - Full Gameplay 4K HDR",
    youtubeID: "k0L8aWP-fCc",
    videoLength: "25:40",
    videoThumbnail: "http://i3.ytimg.com/vi/k0L8aWP-fCc/hqdefault.jpg",
    likes: 1800,
    views: 151000,
    category: ["sports", "simulation"],
    channelName: "The Tech Tales",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UC_snBcW43_6QX7XPpFwc5BQ",
    subscribers: "18.7K",
    date: "2021-08-19T11:06:49",
    description: `I am bowled over by the new Cricket 22 but there are some bugs. The video features an Ashes test match between Australia and England. Recorded on PS5 in 4K HDR.`,
  },
  {
    _id: "ZXtChWPx99w",
    title: "Why Do So Many Gamers Hate Valorant?",
    youtubeID: "ZXtChWPx99w",
    videoLength: "12:15",
    videoThumbnail: "http://i3.ytimg.com/vi/ZXtChWPx99w/hqdefault.jpg",
    likes: 930000000,
    views: 2130000000,
    category: ["action", "adventure"],
    channelName: "Force Gaming",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCGhs9S33RAeT5DEuKTO4Oew",
    subscribers: "9.12M",
    date: "2020-12-14T03:06:49",
    description: `Valorant has been out for a week now and so far the user reviews are not looking great. Why do so many people dislike the game? Let's find out!`,
  },
  {
    _id: "SPJc0-CNczg",
    title: "What's Wrong With Valorant?",
    youtubeID: "SPJc0-CNczg",
    videoLength: "44:17",
    videoThumbnail: "http://i3.ytimg.com/vi/SPJc0-CNczg/hqdefault.jpg",
    likes: 380000000,
    views: 760000000,
    category: ["action", "adventure"],
    channelName: "mrixrt",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCEqX3NzHsxP9MV7YIdq2JzA",
    subscribers: "1.1M",
    date: "2020-11-19T03:06:49",
    description: `Everyone knows Valorant isn't very good, but why can't it compete, and what did it do wrong? Let's break it down. Here's my full review of the game, from Vanguard to Gunplay, Smurfs to Elo, and even Monetization. Let's really dig into this game.`,
  },
  {
    _id: "AP0nkSSlRSg",
    title: "5 Reasons Why VALORANT is BAD",
    youtubeID: "AP0nkSSlRSg",
    videoLength: "6:02",
    videoThumbnail: "http://i3.ytimg.com/vi/AP0nkSSlRSg/hqdefault.jpg",
    likes: 110000000,
    views: 160000000,
    category: ["action", "adventure"],
    channelName: "Oozern",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UC0D7cU54WO5M6kdDnwd6MZQ",
    subscribers: "4.5M",
    date: "2022-02-12T03:06:49",
    description: `Guide on why Valorant is dead and dying (five reasons to explain the flaws of Valorant as well as Riot's fatal mistakes... oh and this is satire 😂)
      This video goes over five different reasons Valorant is a unfun game, as well as whether Valorant is a bad game and also is Valorant a dead game. I personally have lots of fun with my friends on the game and we have some pretty funny moments in Valorant, however, these 5 reasons why Valorant is a bad game are undeniable. But despite the flaws of the RIOT Games FPS Valorant, it is still one of my favorite games because it can be so funny. This guide on why valorant is a bad game is of course satire and for entertainment, so the main goal is to make you laugh through funny moments in the game! After the 5 reasons why valorant is bad, I have some pretty hilarious valorant funny moments. Hope you enjoy the video because it's packed with some of my favorite and funniest moments!`,
  },
  {
    _id: "Ow0xcOL2ErY",
    title: "DYING LIGHT 2 Gameplay Walkthrough",
    youtubeID: "Ow0xcOL2ErY",
    videoLength: "13:56:43",
    videoThumbnail: "http://i3.ytimg.com/vi/Ow0xcOL2ErY/hqdefault.jpg",
    likes: 15000,
    views: 897000,
    category: ["action", "adventure"],
    channelName: "GameClips",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCj4lFy4F5PqXD7d41mCKVYw",
    subscribers: "3.24M",
    date: "2022-01-19T03:06:49",
    description: `DYING LIGHT 2 Gameplay Walkthrough FULL GAME 4K 60FPS No Commentary.
        New Trailers 2022!`,
  },
  {
    _id: "VGt-BZ-SxGI",
    title: "Minecraft Part 1",
    youtubeID: "VGt-BZ-SxGI",
    videoLength: "20:42",
    videoThumbnail: "http://i3.ytimg.com/vi/VGt-BZ-SxGI/hqdefault.jpg",
    likes: 250000000,
    views: 51500000,
    category: ["arcade-and-puzzle", "adventure", "simulation"],
    channelName: "PewDiePie",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UC-lHJZR3Gqxm24_Vd_AJ5Yw",
    subscribers: "111M",
    date: "2019-10-09T03:06:49",
    description: `we go back to our minecraft gameplay roots`,
  },
  {
    _id: "JxJr3qPw-Jg",
    title: "Pubg PC Erangel 2.0 Gameplay",
    youtubeID: "JxJr3qPw-Jg",
    videoLength: "28:15",
    videoThumbnail: "http://i3.ytimg.com/vi/JxJr3qPw-Jg/hqdefault.jpg",
    likes: 72000,
    views: 371000,
    category: ["adventure", "action"],
    channelName: "Rolakek Gaming",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UC1XE53T-ccc7G0cNcPjz6Mg",
    subscribers: "9.68K",
    date: "2019-05-21T03:06:49",
    description: `This is pubg pc erangel 2.0 school gameplay new erangel 2.0 tour tpp in pc in 2020. We are playing pubg pc erangel 2.0 school gameplay new erangel 2.0 tour tpp in 3rd person mode without no commentary.In pubg pc erangel 2.0 school gameplay new erangel 2.0 tour tpp 3rd person (tpp) is much popular than fpp`,
  },
  {
    _id: "QYYfU6Mj1kE",
    title: "BATTLEFIELD 5 Campaign Gameplay Walkthrough",
    youtubeID: "QYYfU6Mj1kE",
    videoLength: "3:24:45",
    videoThumbnail: "http://i3.ytimg.com/vi/QYYfU6Mj1kE/hqdefault.jpg",
    likes: 11000,
    views: 1190000,
    category: ["adventure", "action"],
    channelName: "MKIceAndFire",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UC1bwliGvJogr7cWK0nT2Eag",
    subscribers: "2.98M",
    date: "2021-12-10T03:06:49",
    description: `BATTLEFIELD 5 Walkthrough Part 1 and until the last part will include the full BATTLEFIELD 5 Gameplay on PC. This BATTLEFIELD 5 Single Player Campaign Gameplay is recorded in 1080p HD on the PC and will include the full Campaign. Enjoy!`,
  },
  {
    _id: "sAz5OWaW8aU",
    title: "CALL OF DUTY VANGUARD PS5 Walkthrough Gameplay Part 1",
    youtubeID: "sAz5OWaW8aU",
    videoLength: "1:05:38",
    videoThumbnail: "http://i3.ytimg.com/vi/sAz5OWaW8aU/hqdefault.jpg",
    likes: 87000,
    views: 274000,
    category: ["adventure", "action"],
    channelName: "theRadBrad",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCpqXJOEqGS-TCnazcHCo0rA",
    subscribers: "13M",
    date: "2022-01-01T03:06:49",
    description: `PS5 Call of Duty Vanguard Walkthrough Gameplay Part 1 includes a PS5 Review, Campaign Intro and Story Campaign Mission 1 for PlayStation 5, PS5, Xbox Series X and PC of COD Vanguard 2021 Story Campaign. This Full Game COD Vanguard Gameplay Walkthrough will include Call of Duty Vanguard Story Campaign, Review, PlayStation 5 Gameplay, PS5 Gameplay, Xbox Series X Gameplay, Cinematics, Cut Scenes, Story Missions, Zombie Gameplay, Zombies, DLC and all Single Player Campaign Missions and the Ending. Thanks Activision for the Full Game of Call of Duty Vanguard for PS5!  `,
  },
  {
    _id: "u5UbrOmeczA",
    title: "FALL GUYS Gameplay - SO MUCH FUN",
    youtubeID: "u5UbrOmeczA",
    videoLength: "13:24",
    videoThumbnail: "http://i3.ytimg.com/vi/u5UbrOmeczA/hqdefault.jpg",
    likes: 11000,
    views: 131000,
    category: ["arcade-and-puzzle"],
    channelName: "GameRiot",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCns4T9U8VSIRovKa1a_r7rA",
    subscribers: "1.8M",
    date: "2020-12-27T03:06:49",
    description: `Fall Guys Gameplay - So Much Fun`,
  },
  {
    _id: "qjIGkv0_dEM",
    title: "Crazy Taxi Arcade Longplay Gameplay",
    youtubeID: "qjIGkv0_dEM",
    videoLength: "33:27",
    videoThumbnail: "http://i3.ytimg.com/vi/qjIGkv0_dEM/hqdefault.jpg",
    likes: 8200,
    views: 137000,
    category: ["arcade-and-puzzle", "simulation"],
    channelName: "World of Longplays",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCVi6ofFy7QyJJrZ9l0-fwbQ",
    subscribers: "1.15M",
    date: "2016-12-12T03:06:49",
    description: `Crazy Taxi Arcade Longplay Gameplay`,
  },
  {
    _id: "KnpljMWwy3o",
    title: "Counter-Strike: Global Offensive (2021) - Gameplay",
    youtubeID: "KnpljMWwy3o",
    videoLength: "17:10",
    videoThumbnail: "http://i3.ytimg.com/vi/KnpljMWwy3o/hqdefault.jpg",
    likes: 15000,
    views: 1300000,
    category: ["action", "adventure", "simulation"],
    channelName: "Throneful",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCIw5rbXUrtk31t20Ap5817w",
    subscribers: "2.05M",
    date: "2015-10-19T03:06:49",
    description: `Counter-Strike: Global Offensive (2021) - Gameplay (PC UHD) [4K60FPS]`,
  },
  {
    _id: "edYCtaNueQY",
    title: "Counter-Strike: Global Offensive Trailer",
    youtubeID: "edYCtaNueQY",
    videoLength: "3:54",
    videoThumbnail: "http://i3.ytimg.com/vi/edYCtaNueQY/hqdefault.jpg",
    likes: 435000,
    views: 20300000,
    category: ["action", "adventure", "simulation"],
    channelName: "Valve",
    channelThumbnail:
      "https://image.winudf.com/v2/image/Y29tLm1vYmlsZS5pZ24udHZfaWNvbl8wXzIxOTAxN2Q0/icon.png?w=&fakeurl=1",
    channelLink: "https://www.youtube.com/channel/UCg0FSqPeiGD_lIiPaaAehQg",
    subscribers: "1.75M",
    date: "2021-04-19T03:06:49",
    description: `The cinematic trailer developed at Valve using the Source Filmmaker.
    The beta has provided us with great feedback, and all of the players who joined us recently have helped contribute to the development of the game. CS:GO launches on August 21st, so don't miss your chance to pre-purchase and get into the game early`,
  },
];
